import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: ``,
    children: [
      {
        path: ``,
        loadChildren: () => import(`./0-landing-page/landing-page.module`).then((m) => m.LandingPageModule),
      }
    ]
  },
  {
    path: `dashboard`,
    loadChildren: () => import(`./1-dashboards-platform/dashboards-platform.module`).then((m) => m.DashboardsPlatformModule),
  },
  { path: `**`, redirectTo: `dashboard`, pathMatch: `full` }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
